import { render, staticRenderFns } from "./AmountCards.component.vue?vue&type=template&id=21bf838b&scoped=true&"
import script from "./AmountCards.component.vue?vue&type=script&lang=ts&"
export * from "./AmountCards.component.vue?vue&type=script&lang=ts&"
import style0 from "./AmountCards.component.vue?vue&type=style&index=0&id=21bf838b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf838b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
